<div class="page-content-with-right-sidebar ontario-row ontario-margin-bottom-32-!">
  <div class="main-content">
    <div class="ontario-small-12">
      <div>
        <!--learner info start -->
        @if (workerForm) {
          <div class="training-schedule-div ontario-small-12" [formGroup]="workerForm">
            <div>
              <img alt="Go back" src="assets/images/chevron-down-blue-border.svg" class="rotated back-arrow"
                [routerLink]="this.currentLang == 'en'?'/worker/certifications':'/fr/worker/certifications'">
                <h4 class="border-bottom header-with-arrow">{{'Worker.SetupYourProfile' | translate}}</h4>
              </div>
              <div class="ontario-margin-top-16-! ontario-small-12" [innerHTML]='"Worker.SetupYourLearnerAccount" | translate'></div>
              @if (created) {
                <div class="ontario-margin-top-16-! ontario-margin-bottom-24-! ontario-large-10 banner-row">
                  <app-alert-banner [bannerText]="'Worker.ProfileCreatedBanner' | translate" bannerType="success"></app-alert-banner>
                </div>
                <!--<div>
                <button class="grey-button" (click)="resendVerificationLink()">
                  {{'Worker.ResendEmailVerificationLink' | translate}}
                </button>
              </div>-->
              <br />
              <div class="ontario-margin-top-24-!">
                <h4 class="border-bottom">{{'General.FAQ' | translate}}</h4>
              </div>
              <div class="ontario-margin-top-24-! ontario-margin-bottom-24-! ontario-margin-left-24-! ontario-margin-right-24-!">
                <!--The following text has not been finalized.-->
                <b>{{'Worker.EmailNotReceived' | translate}}</b>
                <div>
                  {{'Worker.CheckSpamOrJunkMail' | translate}}
                </div>
              </div>
            }
            @if (!created) {
              <div class="ontario-margin-top-16-! ontario-margin-bottom-24-! ontario-large-10 banner-row">
                <app-alert-banner [bannerText]="'Worker.NotificeOfCollectionBanner' | translate" bannerType="alert"></app-alert-banner>
              </div>
              <div><h4 class="border-bottom">{{'Worker.LearnersDetails' | translate}}</h4></div>
              <div class="ontario-margin-top-16-! ontario-large-10 banner-row">
                <app-alert-banner [bannerText]="'Worker.LearnerContactDetailsBanner' | translate" bannerType="warning"></app-alert-banner>
              </div>
              <div class="content">
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span class="required-field">{{'Contact.FirstName' | translate}}</span>
                  </mat-label>
                  <input autocomplete="given-name" type="text" class='input-text' [class.disabled]="disableNameInputs" [readOnly]="disableNameInputs" matInput formControlName="firstName" required placeholder="{{'Contact.FirstNameTooltip' | translate}}" />
                  @if ((workerForm.controls['firstName'].invalid &&  workerForm.controls['firstName'].errors && (workerForm.controls['firstName'].dirty || workerForm.controls['firstName'].touched))) {
                    <div>
                      @if (workerForm.controls['firstName'].hasError('required')) {
                        <mat-error>
                          {{'Validation.FirstName.Required' | translate}}
                        </mat-error>
                      }
                      @if (workerForm.controls['firstName'].hasError('maxlength')) {
                        <mat-error>
                          {{'Validation.FirstName.MaxLength' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span class="required-field">{{'Contact.LastName' | translate}}</span>
                  </mat-label>
                  <input autocomplete="family-name" type="text" class='input-text' [class.disabled]="disableNameInputs" [readOnly]="disableNameInputs" matInput formControlName="lastName" required placeholder="{{'Contact.LastNameTooltip' | translate}}" />
                  @if ((workerForm.controls['lastName'].invalid &&  workerForm.controls['lastName'].errors && (workerForm.controls['lastName'].dirty || workerForm.controls['lastName'].touched))) {
                    <div>
                      @if (workerForm.controls['lastName'].hasError('required')) {
                        <mat-error>
                          {{'Validation.LastName.Required' | translate}}
                        </mat-error>
                      }
                      @if (workerForm.controls['lastName'].hasError('maxlength')) {
                        <mat-error>
                          {{'Validation.LastName.MaxLength' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span class="required-field">{{'Worker.EmailAddress' | translate}}</span>
                  </mat-label>
                  <input autocomplete="email" type="email" class='input-text' [class.disabled]="true" [readOnly]="true" matInput formControlName="emailAddress" required placeholder="{{'Contact.EmailAddressTooltip' | translate}}" />
                  @if ((workerForm.controls['emailAddress'].invalid &&  workerForm.controls['emailAddress'].errors && (workerForm.controls['emailAddress'].dirty || workerForm.controls['emailAddress'].touched))) {
                    <div>
                      @if (workerForm.controls['emailAddress'].hasError('pattern')) {
                        <mat-error>
                          {{'Validation.Email.Pattern' | translate}}
                        </mat-error>
                      }
                      @if (workerForm.controls['emailAddress'].hasError('required')) {
                        <mat-error>
                          {{'Validation.Email.Required' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span>{{'Worker.AlternateEmail' | translate}}</span>
                  </mat-label>
                  <input autocomplete="email" type="email" class='input-text' matInput formControlName="altEmailAddress" placeholder="{{'Contact.EmailAddressTooltip' | translate}}" />
                  @if ((workerForm.controls['altEmailAddress'].invalid &&  workerForm.controls['altEmailAddress'].errors && (workerForm.controls['altEmailAddress'].dirty || workerForm.controls['altEmailAddress'].touched))) {
                    <div>
                      @if (workerForm.controls['altEmailAddress'].hasError('exists')) {
                        <mat-error>
                          {{'Contact.EmailAddressExists' | translate}}
                        </mat-error>
                      }
                      @if (workerForm.controls['altEmailAddress'].hasError('pattern')) {
                        <mat-error>
                          {{'Validation.Email.Pattern' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span class="required-field">{{'ClassEnrolment.Phone' | translate}}</span>
                  </mat-label>
                  <input autocomplete="tel" type="text" mask="000-000-0000" class='input-text' matInput formControlName="phone" required placeholder="{{'Contact.PhoneTooltip' | translate}}" />
                  @if ((workerForm.controls['phone'].invalid && workerForm.controls['phone'].errors && (workerForm.controls['phone'].dirty || workerForm.controls['phone'].touched))) {
                    <div>
                      @if (workerForm.controls['phone'].hasError('pattern')) {
                        <mat-error>
                          {{'Validation.Phone.Pattern' | translate}}
                        </mat-error>
                      }
                      @if (workerForm.controls['phone'].hasError('required')) {
                        <mat-error>
                          {{'Validation.Phone.PoliteRequired' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span>{{'Worker.AlternatePhone' | translate}}</span>
                  </mat-label>
                  <input autocomplete="tel" type="text" mask="000-000-0000" class="input-text" matInput formControlName="altPhone" placeholder="{{'Contact.PhoneTooltip' | translate}}" />
                  @if ((workerForm.controls['altPhone'].invalid && workerForm.controls['altPhone'].errors && (workerForm.controls['altPhone'].dirty || workerForm.controls['altPhone'].touched))) {
                    <div>
                      @if (workerForm.controls['altPhone'].hasError('pattern')) {
                        <mat-error>
                          {{'Validation.Phone.Pattern' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span class="required-field">{{'ClassEnrolment.BirthYear' | translate}}</span>
                  </mat-label>
                  <input autocomplete="bday-year" type="text" mask="0000" class='input-text' matInput formControlName="birthYear" required maxlength="4" placeholder="{{'ClassEnrolment.EnterBirthYear' | translate}}" />
                  @if ((workerForm.controls['birthYear'].invalid && workerForm.controls['birthYear'].errors && (workerForm.controls['birthYear'].dirty || workerForm.controls['birthYear'].touched))) {
                    <div>
                      <mat-error>
                        {{'Validation.BirthYear.Required' | translate}}
                      </mat-error>
                    </div>
                  }
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <app-predictive-address-search formGroupName="AddressForm"></app-predictive-address-search>
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span>{{'Worker.POBox' | translate}}</span>
                  </mat-label>
                  <input id="poBox" type="text" class='input-text' matInput formControlName="poBox" placeholder="{{'Worker.POBox' | translate}}" />
                </div>
                <div class="field ontario-large-8 ontario-medium-12">
                  <mat-label class="input-label">
                    <span>{{'Worker.LearnerId' | translate}}</span>
                  </mat-label>
                  <input id="learnerId" type="text" class='input-text' matInput formControlName="learnerId" placeholder="{{'MyLearners.LearnerId' | translate}}" />
                </div>
              </div>
              <div>
                <h4 class="border-bottom">{{'Worker.SharingPermission' | translate}}</h4>
              </div>
              <div class="content">
                <div class="field ontario-small-12">
                  <app-checkbox [checked]="learner.CompletionConsent" (checkedChange)="learner.CompletionConsent=$event" name="{{'Worker.CompletionConsent' | translate}}"></app-checkbox>
                </div>
                <div class="field ontario-small-12">
                  <app-checkbox [checked]="learner.FeedbackConsent" (checkedChange)="learner.FeedbackConsent=$event" name="{{'Worker.FeedbackConsent' | translate}}"></app-checkbox>
                </div>
                <div class="field ontario-small-12">
                  <app-checkbox [checked]="learner.ResearchConsent" (checkedChange)="learner.ResearchConsent=$event" name="{{'Worker.ResearchConsent' | translate}}"></app-checkbox>
                </div>
              </div>
              <div>
                <h4 class="border-bottom">{{'Worker.Subscriptions' | translate}}</h4>
              </div>
              <div class="content">
                <div class="field ontario-small-12">
                  <app-checkbox [checked]="learner.WahInfoConsent" (checkedChange)="learner.WahInfoConsent=$event" name="{{'Worker.WahInfoConsent' | translate}}"></app-checkbox>
                </div>
                <div class="field ontario-small-12">
                  <app-checkbox [checked]="learner.JhscInfoConsent" (checkedChange)="learner.JhscInfoConsent=$event" name="{{'Worker.JhscInfoConsent' | translate}}"></app-checkbox>
                </div>
              </div>
              <div class="ontario-small-12 right-side ontario-padding-bottom-48-! desktop-view">
                <div class="floaty-buttons border-top border-bottom ">
                  <button class="grey-button" (click)="cancelAccountSetup()">
                    {{'Worker.CancelAccountSetUp' | translate}}
                  </button>
                  <button class="link--reset-button" (click)="window.location.reload();">
                    {{'Worker.Reset' | translate}}
                  </button>
                  <button class="blue-button" (click)="saveWorker()">
                    {{'Worker.SetUpAccountProfile' | translate}}
                  </button>
                </div>
              </div>
            }
          </div>
        }
        <!--worker info end-->
      </div>
    </div>
  </div>
  <!--Sidebar db content start -->
  <div class="right-sidebar" style="flex-basis: 34% !important;">
    <div class="grey-box">
      <app-page-content-loop [pageContents]="sideBarContents"></app-page-content-loop>
    </div>
  </div>
  <!--Sidebar db content end-->
  @if (!created) {
    <div class="ontario-small-12 mobile-view">
      <div class="fixed-bottom">
        <div class="menu-div menu-div-left">
          <a (click)="cancelAccountSetup()">
            {{'Worker.Cancel' | translate}}
          </a>
        </div>
        <div class="menu-div menu-div-left">
          <a (click)="window.location.reload();">
            {{'Worker.Reset' | translate}}
          </a>
        </div>
        <div class="menu-div menu-div-right">
          <a (click)="saveWorker()">
            {{'Worker.SetUpAccountProfile' | translate}}
          </a>
        </div>
      </div>
    </div>
  }
</div>
